import { Component, AfterViewInit, ViewChild, inject } from '@angular/core';
import { PlatformLocation,Location } from '@angular/common';
import { Router,NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import {
  TopazSidenavListItem, LoaderService, TopazSidenavComponent, TopazDialogMaxSize
} from '@pearsonvue/topaz-angular-ui';
import {
  faQuestionCircle,
  faEarthAmericas,
  faBars,
  faChevronDown,
  faPenToSquare,
  faEllipsisVertical,
  faBoxArchive,
  faFileExport,
  faTrash,
  faSortDesc,
  faBuilding,
  faAngleLeft,
  faAngleRight,
  faArrowRightFromBracket,
  faCookieBite,
  faCalendar,
  faCalendarCheck,
  faHistory,
  faWallet,
  faFileInvoice,
  faGraduationCap,
  faFlask,
  faMoneyCheckDollarPen,
  faFilePdf,
  faChartLineDown,
  faCaretDown
} from '@fortawesome/pro-solid-svg-icons';

import {
  faUser, faUserGear, faGrid2, faArrowUpRightFromSquare, faGear, faScreenUsers, faBooks, faUsersRectangle, faMessagesQuestion, faDisplayCode,
  faCreditCard,
  faTools,faClipboardCheck,faRedo,faCalendarAlt
} from '@fortawesome/pro-regular-svg-icons';
import { SppdashboardService } from './view/dashboard/sppdashboard.service';
import { DashboardService } from '../app/view/admin/dashboard/dashboard-service.service';
import { Subject, takeUntil, timer } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { AuthService } from './auth/auth.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CookieComponent } from './cookie/cookie.component';

import { environment } from '../../src/environments/env';
import { BreakpointObserver } from "@angular/cdk/layout";
import { UserDataModalComponent } from 'src/app/component/user-data-modal/user-data-modal.component';
import { LiveComponent } from '../app/view/live/live.component';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {

  @ViewChild(TopazSidenavComponent) sideNav!: TopazSidenavComponent;
  public dialogConfig: any = {};
  public reportServiceUrl: any;
  public reportPath: any;
  open: boolean = false;
  title = 'skilingPartnerProtal';
  main: boolean = false;
  user: boolean = false;
  profile: boolean = true;
  spp: boolean = false;
  tab: any = 0;
  activeLink = '';
  ind: any = 0;
  name: any;
  email: any;
  role: any;
  dashboardData: any;
  resp: any;
  status: any;
  alumniStatus: string | null = null;
  partnerId: any;
  isDisabled: boolean = true;
  isPayDisabled: boolean = true;
  isLinkDisabled: boolean = true;
  isLoungeDisabled: boolean = true;
  isAlumniDisabled: boolean = true;
  supportEmail: any = 'mctpvsupport@pearson.com';
  dashboard: boolean = false;
  userMenuItems: { section?: string; links: TopazSidenavListItem[] }[] = [];
  year: any = new Date().getFullYear();//'2025';
  app: boolean = true;
  icons = {
    faUser,
    faUserGear,
    faQuestionCircle,
    faEarthAmericas,
    faBars,
    faChevronDown,
    faCaretDown,
    faPenToSquare,
    faEllipsisVertical,
    faBoxArchive,
    faFileExport,
    faTrash,
    faSortDesc,
    faBuilding,
    faArrowRightFromBracket,
    faCookieBite,
    faGrid2,
    faArrowUpRightFromSquare,
    faScreenUsers,
    faBooks,
    faWallet,
    faFileInvoice,
    faGraduationCap,
    faUsersRectangle,
    faMessagesQuestion,
    faFlask,
    faMoneyCheckDollarPen,
    faGear,
    faDisplayCode,
    faCreditCard,
    faFilePdf,
    faClipboardCheck,
    faRedo,
    faCalendarAlt,
    faAngleLeft,
    faAngleRight
  }

  public isGlobalbar: boolean = false;
  public emailp: any;
  public userid: any;
  public prelogin: boolean = false;
  public isAbout: boolean = false;
  public currentRoute: string = '';

  isTablet = false;
  date: any;

  currentDate: any;
  timelinedate: any;
  rtimelinedate: any;
  timeline: any
  rtimeline: any;
  public window: Window = inject(Window);
  private readonly destroy$ = new Subject<void>();
  public simpleDialog!: MatDialogRef<UserDataModalComponent>;

  private breakpointObserver = inject(BreakpointObserver)

  constructor(private _live: LiveComponent, private Location:Location,private location: PlatformLocation, private dialogModel: MatDialog, private _auth: AuthService, private router: Router, private sppdashboardService: SppdashboardService, private dashboardService: DashboardService, private loaderService: LoaderService) { }

  isExpanded: boolean = true;

  toggleSidenav() {
    this.isExpanded = !this.isExpanded;
  }

  backto(){
    if (this.router.url.startsWith('/find-your-fee')) {
    this.router.navigate(['/prelogin']);
    }
  }

  public openSimpleDialog(): void {
    const dialogRef = this.dialogModel.open(CookieComponent, {
      maxWidth: TopazDialogMaxSize.SMALL
    })
  }
  public fakeRequest(): void {
    timer(0, 500)
      .pipe(
        take(2),
        map((v) => v % 5 === 0)
      )
      .subscribe({
        next: (v) => {
          if (v) {
            this.loaderService.showLoader('Loading...');
          } else {
            this.loaderService.hideLoader();
          }
        }
      });
  }

  fee(){
    this.router.navigate(['/find-your-fee'], { 
    queryParams: { tab: 0 } 
  });
  }

  onSignin(){
    this.router.navigate(['/authcheck'],{ state: { incomingFromApp: true } });
  }

  ngOnInit(): void {
    this.currentRoute = this.router.url;

    if (this.router.url === '/authcheck') {
      this.prelogin = true;
    }

    const initialPath = this.Location.path();
  this.isAbout = initialPath === '/prelogin' || initialPath === '' || initialPath === '/';

  // 2. RUN ON SUBSEQUENT ROUTE CHANGES: Listen to any future navigation movements
  this.router.events.pipe(
    filter(event => event instanceof NavigationEnd)
  ).subscribe(() => {
    this.currentRoute = this.router.url;
    const currentPath = this.Location.path();
    this.isAbout = currentPath === '/prelogin' || currentPath === '' || currentPath === '/';
  });

    this.dialogConfig = {
      type: 'delete',
      forComponent: 'Announcement',
      value: ''
    }


    this.open = false;

    if (localStorage.getItem('SPP') === null) {
      this.spp = false;
    }
    else {
      this.spp = true;
    }

    this.location.onPopState(() => {
      this.isGlobalbar = false;
      this._auth.changeMessage('default message');

    })

    if (sessionStorage.getItem('dashboard') === 'true') {
      this.dashboard = true;
    }

    this.sppdashboardService.gettimeline().subscribe((res: any) => {

      sessionStorage.setItem('timeline', res.data.content[0].mctTimeline);
      sessionStorage.setItem('remindertimeline', res.data.content[0].reminderTimeline);
    })

    this.fakeRequest();
    this._auth.currentMessage.subscribe((res: any) => {

      if (res === 'default message') {
        const storedString = sessionStorage.getItem('link');
        res = sessionStorage.getItem('link') ? storedString !== 'undefined' ? JSON.parse(storedString!) : '' : 'default message';
        this.isGlobalbar = false;
        this.prelogin = false;
         this.user = false;
         if (sessionStorage.getItem('router') === '/admin/dashboard') { 
          if (this.router.url === '/' && sessionStorage.getItem('name')) {
            this.isGlobalbar = true;
            this.user = false;
            this.prelogin = true;
          }
        }
        else if(sessionStorage.getItem('router') !== '/prelogin'){
          if (this.router.url === '/' && sessionStorage.getItem('name')) {
            this.isGlobalbar = true;
            this.user = false;
            this.prelogin = false;
          }
        }
        else if (sessionStorage.getItem('router') !== '/dashboard' && sessionStorage.getItem('router') !== '/terms' && sessionStorage.getItem('router') !== '/expired-mct') {
          if (this.router.url === '/' && sessionStorage.getItem('name')) {
            this.isGlobalbar = true;
            this.user = true;
            this.prelogin = true;
          }
        }

        
      } else {
        sessionStorage.setItem('router', this.router.url);

        this.isGlobalbar = true;
        this.prelogin = true;
      }

      if (res?.role == "ADMIN" && !res?.partnerName) {
        this.sideAdminnav(res.superAdmin);
        this.name = res?.name;
        sessionStorage.setItem('name', res?.name);
        sessionStorage.setItem('email', res?.email);
      } else if (res?.role == "MCTUSER") {

        this.name = res?.name;
        sessionStorage.setItem('name', res?.name);
        this.name = sessionStorage.getItem('name');
        this.email = res?.email;
        sessionStorage.setItem('email', res?.email);
        sessionStorage.setItem('firstname', res?.firstname);
        sessionStorage.setItem('lastname', res?.lastname);

        this.role = res?.role;
        this.partnerId = res?.partnerID;

        this.status = res?.status;
        this.alumniStatus = res?.alumniStatus;

        sessionStorage.setItem('userId', res?.userid);
        sessionStorage.setItem('endDate', res?.mctSubscriptionEndDate);
        sessionStorage.setItem('startDate', res?.mctSubscriptionStartDate);
        this.date = new Date(res?.mctSubscriptionStartDate ? res?.mctSubscriptionStartDate : new Date());
        this.emailp = res?.email;
        this.userid = res?.userid;

        if (sessionStorage.getItem('timeline') && sessionStorage.getItem('remindertimeline')) {
          this.currentDate = new Date();
          this._live.currentLink.subscribe((response: any) => {
            sessionStorage.setItem('enDate', response?.mctSubscriptionEndDate ? response?.mctSubscriptionEndDate : new Date());
            let reminderDate = new Date(sessionStorage.getItem('enDate') || '');
            reminderDate.setDate(reminderDate.getDate() - Number(sessionStorage.getItem('remindertimeline')));
            sessionStorage.setItem('reminderDate', reminderDate.toISOString());
            const previousStatus = response?.previousStatus;
            // reset each emission so stale flags from a previous status don't leak into the new one
            this.isAlumniDisabled = true;
            if (response?.status === 'APPROVE') {
              this.user = true;
              this.isLinkDisabled = true;
              this.isDisabled = true;
              this.isPayDisabled = false;
            }
            else if (response?.status === 'REINSTATE_APPROVE') {
              this.user = true;
              this.isLinkDisabled = true;
              this.isDisabled = true;
              this.isPayDisabled = false;
            }
            else if (response?.status === 'ACTIVE_MCT' || response?.status === 'RENEWAL_REJECT' || response?.status === 'RENEWAL_EXAM') {
              this.user = true;
              this.isDisabled = false;
              this.isLinkDisabled = false;
              this.isPayDisabled = true;
            }
            else if (response?.status === 'RENEWAL') {
              this.isLinkDisabled = false;
              this.isDisabled = false;
              this.isPayDisabled = true;
            }
            else if (response?.status === 'ALUMNI') {
              this.user = true;
              this.isDisabled = true;
              this.isLoungeDisabled = false;
            }
            else if (response?.status === 'RENEWAL_APPROVE' || response?.status === 'REINSTATE_APPROVE') {
              this.isLinkDisabled = true;
              this.isDisabled = false;
              this.isPayDisabled = false;
            } 
           else if(previousStatus === "RENEWAL" && (response?.status==='TEST_OUT_OPEN'|| response?.status==='TEST_OUT_FAIL' ||response?.status==='TEST_OUT_PASS' || response?.status==='ILT_PASS' || response?.status === 'ILT_PAYMENT' || response?.status === 'ILT_FAIL' || response?.status === 'TEST_OUT_PAYMENT')){
             
              this.user = (this.currentRoute === '/dashboard' && (response?.status==='TEST_OUT_FAIL' || response?.status==='ILT_FAIL')) ? false : true;
              this.isDisabled = false;
              this.isPayDisabled = true;
              this.isLinkDisabled = true;
            }
            else if(previousStatus != "RENEWAL" && (response?.status === 'TEST_OUT_OPEN' || response?.status === 'TEST_OUT_PAYMENT'
                      || response?.status === 'TEST_OUT_PASS' || response?.status === 'ILT_PAYMENT' || response?.status === 'ILT_FAIL')
            ) {
              this.user = true;
              this.isPayDisabled = true;
              this.isDisabled = true;
              this.isLinkDisabled = true;
              this.isAlumniDisabled = true; 
            }

            if (previousStatus != "RENEWAL" && (response?.status == 'EXPIRED' || response?.status === 'TEST_OUT_FAIL'  || response?.status === 'ILT_OPEN')) {
              this.user = false;
              this.isDisabled = true;
              this.isPayDisabled = true;
            }
            else if (this.currentDate > (response?.mctSubscriptionEndDate 
                    ? new Date(sessionStorage.getItem('enDate') || '') 
                    : (sessionStorage.getItem('enDate') || '')) 
                        && response != 'default' && response?.status != 'FIRST_LOGIN' && response?.status != 'REINSTATE_APPROVE' && response?.status != 'REINSTATE_SUBMIT' 
                        && response?.status != 'REINSTATE_REJECT' && response?.status != 'RENEWAL_APPROVE' && response?.status != 'RENEWAL' 
                        && response?.status != 'RENEWAL_REJECT' && response?.status != 'OPEN' && response?.status != 'TEST_OUT_OPEN' 
                        && response?.status != 'TEST_OUT_FAIL' && response?.status != 'TEST_OUT_PAYMENT' && response?.status != 'TEST_OUT_PASS' 
                        && response?.status != 'ILT_PAYMENT' && response?.status != 'ILT_FAIL' && response?.status != 'ILT_OPEN'&& response?.status != 'RENEWAL_EXAM') {
              this.user = true;
              this.isDisabled = true;
              this.isLinkDisabled = false;
              this.isAlumniDisabled = false;
              this.isPayDisabled = true;

              if (this.router.url !== '/vouchers' && this.router.url !== '/home' && this.router.url !== '/login') {
                this.router.navigate([this.router.url]);
              }
              else {

                if (response?.status == 'ALUMNI') {
                  this.router.navigate(['/home']);
                } else {
                  this.router.navigate(['/vouchers']);
                }
              }
              if (this.router.url === '/home') {
                this.router.navigate([this.router.url]);
              }

            }
            else if ((new Date(sessionStorage.getItem('reminderDate') || '') <= this.currentDate) 
                        && response != 'default' && response?.status != 'FIRST_LOGIN' && response?.status != 'APPROVE' 
                        && response?.status != 'RENEWAL_APPROVE' 
                        && response?.status != 'RENEWAL' && response?.status != 'RENEWAL_REJECT' && response?.status != 'OPEN' 
                        && response?.status != 'REJECT' && response?.status != 'EXPIRED' && response?.status != 'REINSTATE_APPROVE' 
                        && response?.status != 'REINSTATE_SUBMIT' && response?.status != 'REINSTATE_REJECT' && response?.status != 'TEST_OUT_OPEN' 
                        && response?.status != 'TEST_OUT_FAIL' && response?.status != 'TEST_OUT_PAYMENT' && response?.status != 'TEST_OUT_PASS' 
                        && response?.status != 'ILT_PAYMENT' && response?.status != 'ILT_FAIL' && response?.status != 'ILT_OPEN' && response?.status != 'RENEWAL_EXAM') {

              this.user = true;
              this.isDisabled = false;
              this.isLinkDisabled = false;
              this.isAlumniDisabled = false;
              this.isPayDisabled = true;
            }
          });
        }

        sessionStorage.setItem('status', res?.status);
        if (res?.status == 'OPEN') {
          // this.user=true;
          this._auth._currentUser.next('open');
        }
        else if (res?.status == 'REJECT') {
          this._auth._currentUser.next('reject');
        }
        else if (res?.status == 'RENEWAL_REJECT') {
          this._auth._currentUser.next('renewalreject');
        }
        else if (res?.status == 'RENEWAL') {
          this.user = true;
          this._auth._currentUser.next('renewal');
        }
        else if (res?.status == 'REINSTATE_REJECT') {
          this.user = false;
          this._auth._currentUser.next('expiredreject');
        }
        else if (res?.status == 'REINSTATE_SUBMIT') {
          this.user = false;
          this._auth._currentUser.next('expiredsubmit');
        }
        if (res?.status == 'FIRST_LOGIN') {
          this.user = false;
          this._auth._currentUser.next('no_submit');
        }
        else if (res?.status == 'RENEWAL_APPROVE') {
          this.user = true;
          this._auth._currentUser.next('renewal_approve');
        }
        else if (res?.status == 'REINSTATE_APPROVE') {
          this.user = true;
          this._auth._currentUser.next('expired_approve');
        }

        else if (res?.status == 'APPROVE') {
          this.user = true;

          this._auth._currentUser.next('approve');
        }
        else if (res?.status == 'ACTIVE_MCT') {
          this.user = true;

          this._auth._currentUser.next('active_mct');
        }
        else if (res?.status == 'RENEWAL_REJECT') {
          this.user = true;
        }
      }
    });
  }


  view() {

    setTimeout(() => { window.open("https://iam-social-stage.pearson.com/auth?service=SocialAuthentication&provider=Microsoft&branding=mct&goto=" + environment.BASE_URL + "/ptp/security/ssoBackendRedirect?entryPoint=" + environment.APP_URL + "/#/dashboard&gotoOnFail=" + environment.APP_URL + "/error", '_self') }, 100)
  }

  ngAfterViewInit(): void {
    // document.getElementsByTagName('img')[0].setAttribute("tabindex", "-1")
    // document.getElementsByTagName('img')[0]!.parentElement!.setAttribute("tabindex", "-1")
    // document.getElementsByTagName('img')[0].setAttribute("style", "cursor:text")

    const firstImg = document.getElementsByTagName('img')[0];
    if (firstImg) {
      firstImg.setAttribute("tabindex", "-1");
      if (firstImg.parentElement) {
        firstImg.parentElement.setAttribute("tabindex", "-1");
      }
      firstImg.setAttribute("style", "cursor:text");
    }

    
    if (this.sideNav) {
      this.breakpointObserver
        .observe(['(min-width: 600px) and (max-width: 1024px)'])
        .pipe(takeUntil(this.destroy$))
        .subscribe(result => {
          this.isTablet = result.matches;
          if (this.isTablet) {
            this.sideNav.open.set(false);
          }
        });
    }
  }

  public alertViewAll(): void {
    alert('View all link was clicked');
  }


  isAdmin: any = true;
  adminMenuItems: { section?: string; links: TopazSidenavListItem[] }[] = [
    {
      links: [
        {
          title: 'MCT Dashboard',
          path: '/admin/dashboard',
          icon: faGrid2
        },
        {
          title: 'All MCT Users',
          path: '/admin/all/0',
          icon: faUser
        },
        {
          title: "Active MCT Users",
          path: '/admin/activeMCTUsers',
          icon: faUser
        },
        {
          title: "Processing Time Report",
          path: '/admin/monthly-report',
          icon: faChartLineDown
        },
        {
          title: "MCT Applications",
          path: '/admin/mctformsstatus',
          icon: faUser
        },
        {
          title: 'Expired Subscriptions',
          path: '/admin/expired',
          icon: faCalendarCheck
        },
        {
          title: 'Alumni Subscriptions',
          path: '/admin/alumni',
          icon: faCalendarCheck
        },
        {
          title: 'Profile Merge Requests',
          path: '/admin/profile-merge-requests',
          icon: faHistory
        },
        {
          title: "MCT Admin Management",
          path: '/admin/adminManagement',
          icon: faUser
        },

        // {
        //   // title: 'TestOut Management',
        //   // path: '/admin/testoutTable',
        //   icon: faUser
        // },

        // {
        //   title: 'MCT Reinstatement Management',
        //   path: '/admin/reinstate',
        //   icon: faUser
        // },
        {
          title: 'ISCP Approval Management',
          path: '/admin/approval-managements',
          icon: faClipboardCheck
        },
        {
          title: 'Renewal Management',
          path: '/admin/renewal',
          icon: faRedo
        },
        {
          title: 'Non-ISCP Management',
          path: '/admin/user',
          icon: faUser
        },
        {
          title: 'ILT Session Management',
          path: '/admin/trainingEvent',
          icon: faCalendarAlt
        },

        {
          title: 'MTM File Management',
          path: '/admin/mtm',
          icon: faUser
        },
        {
          title: 'Manage Announcements',
          path: '/admin/mct-announcements',
          icon: faHistory
        },
        {
          title: 'MCT Subscription Settings',
          path: '/admin/settings',
          icon: faCalendar
        },
        {
          title: 'ISC Provider List',
          path: '/admin/iscProviders',
          icon: faUser
        },
        {
          title: 'Application Logs',
          path: '/admin/logs',
          icon: faHistory
        },
        {
          title: 'Payment History',
          path: '/admin/payment-log',
          icon: faHistory
        },
      ],
    }
  ]

  logout() {
    this.isGlobalbar = false;
    this._auth.changeMessage('default message');

    if (localStorage.getItem('SPP') === 'true') {
      this.sppdashboardService.viewAdmin().subscribe((res: any) => {
        localStorage.removeItem('SPP');
      })
    }

    setTimeout(() => { window.open(environment.BASE_URL + "/ptp/security/ssoLogout?entryPoint=" + environment.APP_URL + "/#/prelogin", '_self') }, 500)

  }

  sidenav() {
    this.router.navigate(['/dashboard']);
  }



  sideAdminnav(superAdmin: boolean) {
    this.dashboardService.fetchDashboardData().subscribe((response: any) => {
      if (response.success === true) {
        this.dashboardData = response.data
      } else {
        //for future use if API is ready to send error message in response
        //this.snackbar.open(response.errors,'',{verticalPosition:'top', horizontalPosition:'center'});
      }
    });

    if (superAdmin) {
      const supportMenu = {
        title: 'Support',
        path: '/admin/support-ticket',
        icon: faTools
      };


      const currentList = this.adminMenuItems[0].links;
      // Add supportMenu and ensure uniqueness by title (one-liner)
      this.adminMenuItems[0].links = [...currentList, supportMenu].reduce((acc: TopazSidenavListItem[], item) => {
        if (!acc.some(i => i.title === item.title)) acc.push(item);
        return acc;
      }, []);
    }



    this.router.navigate(['/admin/dashboard']);
    this.main = true;
  }

  // isGreaterThanYear(dateParam: Date) {
  //   const currentDate = new Date();
  //   const oneYearEarlier = new Date(currentDate.setFullYear(currentDate.getFullYear() - 1));
  //   return dateParam < oneYearEarlier;
  // }
}
